// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3ozm6","select":"Header_select__OQCBc","clinic":"Header_clinic__1EUIX"};